import { getMenuMapping } from "@/api/mapping";

const mapping = {
  state: {
    menuMapping: [],
    stationMapping: []
  },
  mutations: {
    // 设置menuMapping
    SET_MENU_MAPPING: (state, menuMapping) => {
      state.menuMapping = menuMapping
      state.menuMapping["Home"] = "首页"
    },
    // 设置stationMapping
    SET_STATION_MAPPING: (state, stationMapping) => {
      state.stationMapping = stationMapping
    }
  },
  actions: {
    // 设置menuMapping
    getMenuMapping({ commit }) {
      getMenuMapping().then(res => {
        const code = res.status.code       
        if(code == 200){
          const menuMapping = JSON.parse(res.data.mappinglist)          
          commit('SET_MENU_MAPPING', menuMapping)
        }        
      }).catch(error => {
        reject(error)
      })
    },
    // 设置stationMapping
    // getStationMapping({ commit }) {
    //   getStationMapping().then(res => {
    //     const code = res.status.code       
    //     if(code == 200){
    //       const 设置stationMapping = JSON.parse(res.data.mappinglist)
    //       commit('SET_STATION_MAPPING', 设置stationMapping)
    //     }        
    //   }).catch(error => {
    //     reject(error)
    //   })
    // }
  }
}


export default mapping



// WEBPACK FOOTER //
// ./src/store/modules/mapping.js